import { render, staticRenderFns } from "./getiBusinessDialog.vue?vue&type=template&id=73ce9580&scoped=true&"
import script from "./getiBusinessDialog.vue?vue&type=script&lang=js&"
export * from "./getiBusinessDialog.vue?vue&type=script&lang=js&"
import style0 from "./getiBusinessDialog.vue?vue&type=style&index=0&id=73ce9580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce9580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ce9580')) {
      api.createRecord('73ce9580', component.options)
    } else {
      api.reload('73ce9580', component.options)
    }
    module.hot.accept("./getiBusinessDialog.vue?vue&type=template&id=73ce9580&scoped=true&", function () {
      api.rerender('73ce9580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/getiBusinessDialog.vue"
export default component.exports